import axios from "axios";
import { authorizedHeader } from "./authorization";
import { dataTableFieldsApiUrl, vehicleDataApiUrl } from "components/Common/endpoints";

export const getTableFields = async (vehicleDataTable = "TELEMETRY") => {
  const response = await axios({
    method: "GET",
    url: dataTableFieldsApiUrl,
    params: {
      vehicleDataTable,
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
}

export const getLiveData = async (vId, field, dataTable, timeInterval, sampling) => {
  // console.log('calling live api--', vId, field, dataTable, timeInterval+1, sampling)
  const response = await axios({
      method: "POST",
      url: vehicleDataApiUrl,
      params: {
        vIdVal: vId,
        startTime: Date.now() - ((timeInterval+1) * 60 * 1000),
        endTime: Date.now() - (30 * 1000),
        dataTable,
        samplingFrequency: sampling ? sampling : null,
        showErrors: false
      },
      data: {
        field,
      },
      headers: authorizedHeader(),
    });
    return response.data;
}

// export const getLiveData = async (imei, startTime, endTime, dataTable='', 
//     field=[], showErrors=false) => {
//     const response = await axios({
//         method: "GET",
//         url: vehicleDataApiUrl,
//         params: {
//           vldVal: imei,
//           startTime: Date.now() - (5 * 60 * 1000), // 5mins before now
//           endTime: Date.now(),
//           dataTable,
//           field,
//           showErrors: false
//         },
//         headers: authorizedHeader(),
//       });
//       return response?.data;
// }

export const getData = async (vId, field, dataTable, startTime, endTime, agg) => {
  const response = await axios({
      method: "POST",
      url: vehicleDataApiUrl,
      params: {
        vIdVal: vId,
        startTime,
        endTime, 
        dataTable,
        samplingFrequency: agg,
        showErrors: false
      },
      data: {
        field,
      },
      headers: authorizedHeader(),
    });
    return response.data;
}
